import {Formik} from 'formik';

import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    PersonaFormValues,
    PersonaRecordFormProps,
} from '../types';
import {stage} from '../../../config/stage';

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: PersonaRecordFormProps) => {

    // RETURN the promise (FNP-932) — see testing-actions/forms/RecordForm.tsx.
    // Without it Formik clears `isSubmitting` synchronously, so Save is never
    // disabled and a double-click fires two mutations.
    const onSubmit = (values: PersonaFormValues) => {
        return handleSubmit(values);
    };

    return (
        <Formik
            initialValues={record}
            validationSchema={RecordSchema}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons
                    handleSubmit={handleSubmit}
                    isSubmitting={isSubmitting}
                    handleCancel={handleCancel}
                    debug={false && stage === 'ide'}
                    {...rest}
                >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
